import { pushToDataLayer } from './pushToDataLayer';

/**
 * Envoie l'événement de liste d'éléments vue pour le carrousel au dataLayer.
 *
 * @param {string} item_list_id - L'ID de la liste d'éléments.
 * @param {string} item_list_name - Le nom de la liste d'éléments.
 * @param {Array} items - Un tableau d'éléments du carrousel.
 */
export const pushCarrouselViewItemListToDataLayer = (item_list_id, item_list_name, items) => {
    try {
        if (!Array.isArray(items)) {
            console.warn('DataLayer Invalid items:', items);
            return;
        }

        const eventParams = {
            item_list_id,
            item_list_name,
            items: items.map((item, index) => {
                if (!item || !item.entiteId || !item.titre || !item.carouselLabel || !item.slug) {
                    console.warn('Invalid item:', item);
                    return null;
                }
                return {
                    item_id: item.entiteId,
                    item_name: item.titre,
                    item_category: item.carouselLabel,
                    index,
                    location_id: item.slug,
                    item_list_id,
                    item_list_name
                };
            }).filter(Boolean), // Supprime tous les éléments nuls
        };

        pushToDataLayer('view_item_list', eventParams);
    } catch (error) {
        console.error('DataLayer Error in pushCarrouselViewItemListToDataLayer:', error);
    }
};

/**
 * Envoie l'événement de sélection d'élément pour le carrousel au dataLayer.
 *
 * @param {string} item_list_id - L'ID de la liste d'éléments.
 * @param {string} item_list_name - Le nom de la liste d'éléments.
 * @param {Object} item - L'élément à sélectionner.
 */
export const pushCarrouselSelectItemToDataLayer = (item_list_id, item_list_name, item) => {
    try {
        if (!item || !item.entiteId || !item.titre || !item.carouselLabel || !item.slug) {
            console.warn('DataLayer Invalid item:', item);
            return;
        }

        const eventParams = {
            item_list_id,
            item_list_name,
            items: [
                {
                    item_id: item.entiteId,
                    item_name: item.titre,
                    item_category: item.carouselLabel,
                    index: 0,
                    location_id: item.slug,
                    item_list_id,
                    item_list_name
                }
            ]
        };

        pushToDataLayer('select_item', eventParams);
    } catch (error) {
        console.error('DataLayer Error in pushCarrouselSelectItemToDataLayer:', error);
    }
};
